export default {"src":"/evde-internet/_next/static/media/VFSPM.7e55642f.svg","height":120,"width":120};